<template>
  <div class="layout-copyright">
    <div class="content">
      <p class="server-box">
        <!-- <img src="@/assets/img/Logo-AFCwave.png" /><br class="newline" /> -->
        AFCWIFI Limited © 2019. ALL right reserved.
      </p>
      <p class="police-box" v-if="res">
        <a target="_blank" :href="res.beian1_url">
          <img src="@/assets/img/Copyright/police.png"> 
          {{res.beian1}}&nbsp;&nbsp; 
        </a><br class="newline" />
        <a target="_blank" :href="res.beian2_url">{{res.beian2}}&nbsp;&nbsp; </a>
        <a @click="showPri()">隐私政策</a> 
        <!-- <remote-script src="https://szcert.ebs.org.cn/govicon.js?id=3280d7bb-faab-4e1b-a6c8-e4aa2e1e6daa&width=15&height=20&type=1" charset="utf-8" id="ebsgovicon"></remote-script> -->
      </p>
    </div> 
    <div v-show="showPrivacy" class="privacy" v-if="res">
      <div class="pri-content" v-html="res.privacy">
      </div>
      <a class="hiddenBtn" @click="hidePri()">确定</a>      
    </div>
  </div>
</template>

<script>
import {Copyright} from '@/api/index.js'
export default {
  name: 'LayoutCopyright',
  data() {
    return {
      res: null,
      showPrivacy: false
    };
  },
  components: {
    
  },
  methods: {
    initData(){
      Copyright({}).then(res => {
        this.res = res.data;
      })
    },
    showPri(){
      this.showPrivacy = !this.showPrivacy;
    },
    hidePri(){
      this.showPrivacy = false;
    }
  },
  created(){
    this.initData()
  }
};
</script>

<style lang="" scoped>
.layout-copyright{
  min-height: 100px;
}

.content{
  width: 88%;
  margin: 0 auto;
  border-top: 2px solid #993333;
}

.server-box{
  display: inline-block;
  min-height: 34px;
  line-height: 34px;
  text-align: center;
  margin: 20px 0;
  color: #666;
}

.server-box img{
  display: inline-block;
  height: 26px;
  margin: 4px 0;
}

.police-box{
  display: inline-block;
  float: right;
  min-height: 34px;
  line-height: 34px;
  text-align: center;
  margin: 20px 0;
  color: #666;
}

.police-box img{
  display: inline-block;
  height: 26px;
  margin: 4px 10px;
}

.police-box a{
  color: #666;
}

.newline{
  display: none;
}

.privacy{
  width: 70%;
  height: 80%;
  min-width: 650px;
  background-color: #FFFFFF;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 0 20px rgba(0,0,0,0.8);
  z-index: 10000;
  overflow-y: scroll;
  overflow-x: hidden;
}

.pri-content{
  width: 80%;
  margin: 0px  auto;
  padding: 80px 0 40px;
}

.pri-content >>> p{
  font-size: 16px;
}

.hiddenBtn{
  display: block;
  width: 90px;
  height: 40px;
  line-height: 40px;
  margin: 20px auto 40px;
  text-align: center;
  background-color: #3a8ee6;
  color: #FFF;
  border-radius: 5px;
  cursor: pointer;
  text-decoration: none;
}

@media screen and (max-width: 920px){

  .newline{
    display: block;
  }
  .server-box{
    display: block;
    line-height: 28px;
    margin: 10px 0 0px;
  }
  .police-box{
    display: block;
    float: none;
    line-height: 28px;
    margin: 0px;
  }

  .content{
    padding-bottom: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Layout/LayoutCopyright.vue